import PasswordInput from './password-input.vue'
export type { PasswordInputProps } from './props'
export default PasswordInput